import Button from '../components/Button';
import { Subtitle } from '../components/Typography/styles';
import { Title } from '../routes/onboard/styles';

import auth from './Auth';

// Full-page state for a logged-in user who belongs to no active team, rendered by AppInner before
// any teamId-dependent route mounts.
const NoTeams = () => (
  <div className="mx-auto flex h-screen flex-col items-center justify-center gap-5">
    <Title style={{ textAlign: 'center', maxWidth: 1000, marginBottom: 0 }}>
      You're not a member of any team
    </Title>
    <Subtitle>Your team access has been removed. Please contact your administrator to regain access.</Subtitle>
    <Button onClick={() => auth.logout()} color="secondary" variant="contained" style={{ marginTop: 24 }}>
      Log out
    </Button>
  </div>
);

export default NoTeams;
